"use strict";

var _toConsumableArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var PERMISSIONS_PATH = {
  teamMember: ['system', 'environmentMember'],
  user: ['user']
};

exports.getPermissions = function (data, type) {
  return R.pipe(R.pathOr([], PERMISSIONS_PATH[type]), R.pipe(R.pathOr([], ['permissions', 'items']), R.groupBy(R.prop('resourceType')), R.mapObjIndexed(R.indexBy(R.prop('resource')))))(data);
};

exports.getRoles = function (data, type) {
  return R.pipe(R.pathOr([], _toConsumableArray(PERMISSIONS_PATH[type]).concat(['roles', 'items'])), R.map(function (_ref) {
    var name = _ref.name;
    return name;
  }))(data);
};